import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule, MatIconModule, MatInputModule } from '@angular/material';
import { downgradeComponent } from '@angular/upgrade/static';
import { GooglePlacesModule } from '@mandae/ng-utils/google-places';
import { MaskModule } from '@mandae/ng-utils/mask';
import * as angular from 'angular';
import { TextMaskModule } from 'angular2-text-mask';
import { FormsComponentsModule } from '../../forms/components/forms-components.module';
import { FormsModule as WebappFormsModule } from '../../forms/forms.module';
import { AddressCheckinButtonComponent } from './address-checkin-button/address-checkin-button.component';
import { AddressCheckinComponent } from './address-checkin/address-checkin.component';
import { AddressFormComponent } from './address-form/address-form.component';
import { DisplayAddressComponent } from './display-address/display-address.component';

@NgModule({
  declarations: [
    AddressCheckinComponent,
    AddressCheckinButtonComponent,
    AddressFormComponent,
    DisplayAddressComponent,
  ],
  entryComponents: [
    AddressCheckinComponent,
    AddressFormComponent,
    AddressCheckinButtonComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    FormsComponentsModule,
    MaskModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    TextMaskModule,
    WebappFormsModule,
  ]
})
export class UserActionsModule { }

try {
  angular
    .module('mandaeApp')
    .directive('appActionAddressCheckin', downgradeComponent({ component: AddressCheckinComponent }))
    .directive('appActionAddressCheckinButton', downgradeComponent({ component: AddressCheckinButtonComponent }));
} catch (e) {}
